import api from "@/router/api";

export default {
  async listarParcerias(params = {}) {
    const response = await api.get("/api/solicitacoes-parceria", {
      params,
    });

    return response.data;
  },

  async criarParceria(dadosParceria) {
    const response = await api.post(
      "/api/solicitacoes-parceria",
      dadosParceria
    );

    return response.data;
  },

  async buscarParceriaPorId(id) {
    const response = await api.get(`/api/solicitacoes-parceria/${id}`);

    return response.data;
  },
};
